import { ReduxHelper } from "@al/base-lib";

import * as signActions from "./actions";
import { defaultCountryAddress } from "./constants";

function request(url) {
  return ({ async }) =>
    async(async (param, ctx) => await ctx.io.post(url, { ...param }, { headers: { "device-id": ctx.deviceId } }));
}

const helpers = ReduxHelper.combine({
  // 获取用户信息
  asyncGetSignState: request("/mapi/personal/user/user-info-detail/get"),
  // 获取默认地址信息
  asyncGetDefaultAddress: request("/mapi/personal/user/address/v1/country/default-address-query"),
  // 通过地址id查询用户地址详情
  asyncGetAddressById: request("/mapi/personal/user/address/v1/getById"),
  // 欧洲M站 - 欧洲M站- 登出接口
  asyncLogout: request("/mapi/personal/public/mall/logout"),
});

// 用于获取用户登录信息的，异步 action 使用方法参考 https://www.redux.org.cn/docs/advanced/AsyncActions.html
export function getSignState() {
  return (dispatch) => {
    return dispatch(helpers.actions.asyncGetSignState()).then(({ success, data }) => {
      if (success) {
        dispatch(signActions.updateSignState(data));
      } else {
        dispatch(signActions.clearSignState());
      }
    });
  };
}

// 用于获取默认地址信息
export function getAddressInfo(countryId, conAddressId, reRequest) {
  return (dispatch, getState) => {
    const state = getState();
    const addressInfo = state.sign.addressInfo;
    // 存在地址信息、且不需要重新刷新时
    if (addressInfo && !reRequest) {
      // 不存在地址id，或者地址id等于已存在的地址信息id时，则直接返回已缓存地址信息
      if (!conAddressId || conAddressId === addressInfo.conAddressId) {
        return addressInfo;
      }
    }
    if (conAddressId) {
      // 有地址id，则直接根据id获取详情
      return dispatch(helpers.actions.asyncGetAddressById({ conAddressId })).then(({ data }) => {
        dispatch(signActions.updateAddressInfo(data || { countryId, ...defaultCountryAddress[countryId] }));
      });
    } else {
      // 否者获取默认地址信息
      return dispatch(helpers.actions.asyncGetDefaultAddress()).then(({ data }) => {
        dispatch(signActions.updateAddressInfo(data || { countryId, ...defaultCountryAddress[countryId] }));
      });
    }
  };
}

export function logout() {
  return (dispatch, getState) => {
    dispatch(helpers.actions.asyncLogout());
  };
}

export default helpers;
